import { Box, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { ChartType } from "@/features/chat/model/chatTypes";
import { getChartTypeIcon } from "@/features/chat/ui/chartTypeIcons";

type ChartTypeSelectorProps = {
  value: ChartType;
  availableTypes: ChartType[];
  onChange: (chartType: ChartType) => void;
};

export function ChartTypeSelector({
  value,
  availableTypes,
  onChange,
}: ChartTypeSelectorProps) {
  const { t } = useTranslation("chat");

  return (
    <Box
      role="radiogroup"
      aria-label={t("response.charts.chartType")}
      sx={{ display: "flex", alignItems: "center", gap: 0, flexShrink: 0 }}
    >
      {availableTypes.map((chartType) => {
        const Icon = getChartTypeIcon(chartType);
        const label = t(`response.charts.types.${chartType}`);
        const isSelected = value === chartType;

        return (
          <Tooltip key={chartType} title={label}>
            <IconButton
              size="small"
              role="radio"
              aria-checked={isSelected}
              aria-label={label}
              onClick={() => onChange(chartType)}
              sx={{
                color: isSelected ? "var(--theme-primary)" : "var(--theme-text-secondary)",
                bgcolor: isSelected ? "var(--theme-overlay-olive-15)" : "transparent",
                "&:hover": {
                  bgcolor: isSelected
                    ? "var(--theme-overlay-olive-15)"
                    : "var(--theme-hover-secondary)",
                },
              }}
            >
              <Icon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      })}
    </Box>
  );
}
